module.exports = __webpack_public_path__ + "static/media/logogg.17982da3.jpg";